exports.SimpleNotificationsModule = require('./lib/simple-notifications.module').SimpleNotificationsModule;
exports.SimpleNotificationsComponent = require('./lib/simple-notifications.component').SimpleNotificationsComponent;
exports.NotificationsService = require('./lib/notifications.service').NotificationsService;
exports.PushNotificationsService = require('./lib/push-notifications.service').PushNotificationsService;
exports.Icons = require('./lib/icons').Icons;
exports.Options = require('./lib/options').Options;
exports.Notification = require('./lib/notification').Notification;




//////////////////
// WEBPACK FOOTER
// ./~/angular2-notifications/components.js
// module id = 589
// module chunks = 0